// extracted by mini-css-extract-plugin
export var feedbackPrompt = "mqtGgwiz";
export var feedbackHeader = "sNEka7eH";
export var feedbackTitle = "aDJEx9a8";
export var closeIcon = "aJjEnbkx";
export var thumbs = "zzC6faVz";
export var thumb = "VgbonbXi";
export var feedbackForm = "_8SNCfWwv";